import { ChangeDetectorRef, Component, Inject, Input, SimpleChanges } from '@angular/core';
import { ResultsInvoice } from '../../../interface/company-client.interface';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { animate, style, transition, trigger } from '@angular/animations';

@Component({
  selector: 'app-detalle-fact-v',
  templateUrl: './detalle-fact-v.component.html',
  styleUrls: ['./detalle-fact-v.component.scss'],
  animations: [
    trigger('fadeIn', [ 
      transition('void => *', [
        style({ opacity: 0 }), 
        animate(1150, style({opacity: 1}))
      ]) 
    ])
  ]
})
export class DetalleFactVComponent {

  //@Input() resultsInvoice?: ResultsInvoice;
  hasOrder: boolean = false;

  constructor(private cdref: ChangeDetectorRef, @Inject(MAT_DIALOG_DATA) public data: ResultsInvoice, public dialogRef: MatDialogRef<DetalleFactVComponent>) {
    
  }

  ngOnInit() {
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes['resultsInvoice']) {
      const results = changes['resultsInvoice'].currentValue;
    }
    if (changes['requestInvoice']) {
      const request = changes['requestInvoice'].currentValue;
    }
  }

  ngAfterContentChecked() {
    this.cdref.detectChanges();
  }

  closeDialog(): void {
    this.dialogRef.close();
  }

  mostrarDatosOperacion() {
    this.hasOrder = !this.hasOrder;
  }

}